import { Fragment, forwardRef } from "react";
import "./mgEditorial.css";

export const isMindshareEditorial = ({ pathname, search = "" }) =>
  pathname === "/mindshare" && new URLSearchParams(search).get("editorial") === "1";

function getSelectionPosition(index, count) {
  if (count === 1) return "only";
  if (index === 0) return "first";
  if (index === count - 1) return "last";
  return "middle";
}

export function MGSectionHeader({ children, index, accent = "coral", className = "", ...props }) {
  return (
    <div className={`mg-section-header mg-accent-${accent} ${className}`} {...props}>
      {index && <span className="mg-section-index" aria-hidden="true">{index}</span>}
      <h2>{children}</h2>
      <span className="mg-section-rule" aria-hidden="true" />
    </div>
  );
}

export function MGHeadingToggle({ label, value, options, onChange, angledSelection = false }) {
  return <span className="mg-heading-toggle" role="group" aria-label={label}>
    {options.map((option, index) => {
      const selected = value === option.value;
      return <Fragment key={option.value}>
        {index > 0 && <span className="mg-heading-separator" aria-hidden="true">/</span>}
        <button
          type="button"
          aria-pressed={selected}
          className={angledSelection ? "mg-heading-toggle-angled" : undefined}
          data-selection-position={angledSelection && selected ? getSelectionPosition(index, options.length) : undefined}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      </Fragment>;
    })}
  </span>;
}

export const MGTechFrame = forwardRef(function MGTechFrame(
  { as: Element = "div", className = "", children, ...props }, ref
) {
  return <Element ref={ref} className={`mg-tech-frame ${className}`} {...props}>{children}</Element>;
});

export const MGIconButton = forwardRef(function MGIconButton(
  { className = "", type = "button", ...props }, ref
) {
  return <button ref={ref} type={type} className={`mg-icon-button ${className}`} {...props} />;
});

export function MGRankBadge({ rank, className = "", ...props }) {
  return <span className={`mg-rank-badge ${className}`} {...props}>#{rank}</span>;
}

export const MGFilterControl = forwardRef(function MGFilterControl(
  { as: Element = "div", className = "", ...props }, ref
) {
  return <Element ref={ref} className={`mg-filter-control ${className}`} {...props} />;
});
